import { Skeleton } from "~/components/ui/skeleton";

export function SearchSuggestionsSkeleton() {
  return (
    <div className="flex flex-col items-start justify-start gap-[10px]">
      {/* Search suggestion items */}
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={`suggestion-${index}`} className="inline-flex w-full cursor-pointer items-center justify-start gap-1">
          {/* Search icon skeleton */}
          <Skeleton className="h-[16px] w-[16px] rounded" />
          {/* Suggestion text skeleton */}
          <Skeleton className="h-5 w-32" />
        </div>
      ))}
    </div>
  );
}

export function SearchTrendingKeywordsSkeleton() {
  return (
    <div className="flex flex-row flex-wrap gap-[10px]">
      {/* Trending keyword items */}
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={`trending-${index}`}
          className="inline-flex h-[28px] items-center justify-start gap-1 rounded-[12px] bg-[#F2F2F2] px-[8px] py-[4px]"
        >
          {/* Hot icon for first item */}
          {index === 0 && <Skeleton className="h-[16px] w-[16px] rounded" />}
          {/* Keyword text skeleton */}
          <Skeleton className="h-4 w-20" />
        </div>
      ))}
    </div>
  );
}
